import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=38d3b73a&scoped=true&"
import script from "./productDialog.vue?vue&type=script&lang=js&"
export * from "./productDialog.vue?vue&type=script&lang=js&"
import style0 from "./productDialog.vue?vue&type=style&index=0&id=38d3b73a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3b73a",
  null
  
)

export default component.exports